import { createFileRoute } from "@tanstack/react-router";
import { PermissionGate } from "@/shared/auth/PermissionGate";
import { tienePermisoEnSesion } from "@/shared/auth/permiso-en-sesion";
import { PERMISOS } from "@/lib/permisos";
import { ErrorAlert } from "@/components/ui";
import { DisenadorFlujoSkeleton } from "@/features/admin-notificaciones/components/disenador/DisenadorFlujoSkeleton";
import { DisenadorFlujoPage } from "@/features/admin-notificaciones/components/disenador/DisenadorFlujoPage";
import {
  catalogoNotificacionesQueryOptions,
  flujoQueryOptions,
} from "@/features/admin-notificaciones/hooks/use-notificaciones";

/** Ruta `/admin/notificaciones/$id` · diseñador gráfico de un flujo (React Flow). */
export const Route = createFileRoute("/_authed-tw/admin/notificaciones/$id")({
  loader: ({ context: { queryClient }, params: { id } }) =>
    tienePermisoEnSesion([PERMISOS.adminNotificaciones])
      ? Promise.all([
      queryClient.ensureQueryData(catalogoNotificacionesQueryOptions),
      queryClient.ensureQueryData(flujoQueryOptions(id)),
    ])
      : undefined,
  pendingComponent: DisenadorFlujoSkeleton,
  component: () => (
    <PermissionGate permisos={[PERMISOS.adminNotificaciones]}>
      <DisenadorFlujoPage />
    </PermissionGate>
  ),
  errorComponent: ({ error }) => <ErrorAlert error={error} />,
});
